<form>
  <div fxLayout="row" fxLayoutAlign="center center">
    <div fxFlex="400px" [formGroup]="editForm">
      <mat-card appearance="outlined" class="password-reset-card">
        <div fxLayout="column" fxFlexFill fxLayoutAlign="start stretch">
          <h3 mat-dialog-title>パスワード再設定</h3>
          <mat-form-field>
            <mat-label>パスワード</mat-label>
            <input matInput type="password" placeholder="パスワード" id="password" formControlName="password" autocomplete="off" required>
            <mat-error *ngIf="passwordControl.invalid">{{ getErrorMessageToPassword() }}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>確認パスワード</mat-label>
            <input matInput type="password" placeholder="確認パスワード" id="comfirm_password" formControlName="comfirm_password" autocomplete="off" required>
            <mat-error *ngIf="comfirmPasswordControl.invalid">{{ getErrorMessageToComfirmPassword() }}</mat-error>
          </mat-form-field>
          <div class="password-reset">
            <button mat-button color="primary" (click)="passwordReset()" [disabled]="editForm.invalid"><mat-icon class="mat-icon-event-btn">account_circle</mat-icon>{{ 'パスワード再設定' | translate }}</button>
          </div>
          <div fxLayout="row" fxFlexFill fxLayoutAlign="center center">
            <span style="color: #FF0000; font-size:11px;">
              ＊＊＊＊＊　　注意点　　＊＊＊＊＊
            </span>
          </div>
          <div fxLayout="row" fxFlexFill fxLayoutAlign="space-between center">
            <span style="color: #FF0000; font-size:11px;">
              パスワードは、半角英字（大文字、小文字）数字をそれぞれ１種類以上含む１０文字以上で設定してください。<br>
              既にグーグル・アカウントでログイン済みの場合、同じメールアドレスでのアカウント登録は行えませんので、ご注意ください。
            </span>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</form>
